<mat-card class="user-type-selection-modal-card">
<header>
    <div class="logo">
        <img [src]="appIconPaths.PARAMOUNT_CP_CENTRAL_LOGO" alt="Logo" class="logo-img" />
    </div>
    <br>
    <h3 class="title  paramount-font-class xx-large" style="color: white;">
        {{`Request New User?`}}
    </h3>
</header>
<br>
<mat-dialog-content class="dialog-content">
      <!-- <mat-radio-group [(ngModel)]="selectedOption">
        <mat-radio-button value="Internal">Internal</mat-radio-button>
        <mat-radio-button value="External">External</mat-radio-button>
      </mat-radio-group> -->

      <div style="    display: flex;
      justify-content: center;font-size: large;">
                  <div style="cursor: pointer;     gap: 10px;
      display: flex;">
                      <label *ngFor="let opt of userTypeOptions" style="color: white;">
                          <input type="radio"  name="userType" [value]="opt.value" [(ngModel)]="selectedUserType"
                               />
                          {{ opt.label | titlecase}}
                      </label>
                  </div>
              </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-footer" style="align-items: end;">
        <button mat-button (click)="onCancel()" style="color: white;background-color: rgba(0, 0, 0, 0);">Cancel</button>
        <button mat-button (click)="onConfirm()" style="color: white;background-color: #0046cc;">Confirm</button>
      
      
    </mat-dialog-actions>
</mat-card>